// src/components/Contact.js
import { useState } from "react";
// --- CORRECTED IMPORT ---
import '../styles/global.css'; // This is crucial for imageFrame (import directly for global styles)
// ------------------------

// --- IMPORT FOR BILLBOARD PHOTO ---
import billboardPhoto from '../assets/board.jpg';
import buildingPhoto from '../assets/building.jpg'; // Assuming you have a building photo in your assets folder
// --- NEW IMPORT FOR BUILDING PHOTO ---
// Removed direct import for buildingWithBoardPhoto to use a placeholder URL directly
// import buildingWithBoardPhoto from '../assets/building_with_board.jpg'; 
// Using a placeholder URL for the building photo for now.
// When you get the actual picture, place it in your assets folder and uncomment the import above,
// then change 'buildingWithBoardPhoto' below to use the imported variable.
const buildingWithBoardPhotoPlaceholder = buildingPhoto;
// ---------------------------------------

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "", "bot-field": "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = "Invalid email address";
    if (!formData.message.trim()) newErrors.message = "Message cannot be empty";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const encode = (data) => {
    return Object.keys(data)
      .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setSubmitting(true);
    setSubmitError(null);

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...formData }),
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", message: "", "bot-field": "" });
      } else {
        setSubmitError("There was an issue with your submission. Please try again.");
        console.error("Form submission failed:", response.status, response.statusText);
      }
    } catch (error) {
      setSubmitError("Network error. Please check your connection and try again.");
      console.error("Form submission error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" style={{ backgroundColor: '#e3f2fd' }} className="text-dark py-5">
      <div className="container">
        <h2 className="text-center mb-4">Get In Touch</h2>

        <div className="row g-4">
          {/* Left Column: Images and Map */}
          <div className="col-md-6">
            <div className="p-4 bg-white rounded shadow-sm h-100 d-flex flex-column">
              <h3 className="mb-3" style={{ color: '#055160' }}>Visit Us</h3>

              {/* Images in a responsive row */}
              <div className="row g-3 mb-4 justify-content-center">
                <div className="col-sm-6 d-flex justify-content-center"> {/* Smaller column for each image */}
                  {/* --- Billboard Photo (FRAMED) --- */}
                  <div
                    className="imageFrame" // Using global CSS class directly
                    style={{ maxWidth: '250px' }} /* Adjusted max-width for smaller column */
                  >
                    <img
                      src={billboardPhoto}
                      alt="Outdoor sign for Shikitari Japanese Language Academy at Sabhagriha Chowk, Pokhara."
                      className="img-fluid rounded"
                      loading="lazy"
                    />
                    <p className="mt-3">Our outdoor sign.</p> {/* Shorter description */}
                  </div>
                </div>
                <div className="col-sm-6 d-flex justify-content-center"> {/* Smaller column for each image */}
                  {/* --- NEW: Building Photo (FRAMED) --- */}
                  <div
                    className="imageFrame" // Using global CSS class directly
                    style={{ maxWidth: '250px' }} /* Adjusted max-width for smaller column */
                  >
                    <img
                      src={buildingWithBoardPhotoPlaceholder} // Using the placeholder URL
                      alt="Exterior view of Shikitari Japanese Language Academy building with company board visible."
                      className="img-fluid rounded"
                      loading="lazy"
                    />
                    <p className="mt-3">Our building.</p>
                    <p>Exterior view of Shikitari Japanese Language Academy building with company board visible.</p>
                  </div>
                </div>
              </div>
              {/* --- END: Images --- */}

              {/* Map takes up remaining vertical space */}
              <div style={{ flexGrow: 1, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14133.117101153358!2d83.985583!3d28.209389!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDEyJzMzLjgiTiA4M8KwNTknMDguMSJF!5e0!3m2!1sen!2snp!4v1720412370000!5m2!1sen!2snp"
                  width="100%"
                  height="100%"
                  style={{ minHeight: '400px', border: 0 }} /* Increased minHeight for more vertical balance */
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>

          {/* Right Column: Contact Us Form */}
          <div className="col-md-6">
            {/* Removed position:relative from this div as the animated background is gone */}
            <div className="p-4 bg-white rounded shadow-sm h-100">
              {/* Removed: Animated background for the form */}
              {/* Removed: <div className="form-animated-background"> ... </div> */}

              {/* Form content no longer needs z-1 as animated background is gone */}
              <div>
                <h3 className="mb-3" style={{ color: '#055160' }}>Contact Us</h3>

                {submitted ? (
                  <div className="text-center">
                    <h4 className="fw-bold">Thank you!</h4>
                    <p>We will be contacting you soon.</p>
                    <button className="btn btn-light mt-3" onClick={() => setSubmitted(false)}>Send another message</button>
                  </div>
                ) : (
                  <form
                    name="contact"
                    method="POST"
                    data-netlify="true"
                    netlify-honeypot="bot-field"
                    onSubmit={handleSubmit}
                  >
                    <input type="hidden" name="form-name" value="contact" />

                    {/* HONEYPOT FIELD - TEMPORARILY COMMENTED OUT FOR TESTING */}
                    {/*
                    <p style={{ display: 'none' }}>
                      <label>
                        Don’t fill this out: <input name="bot-field" value={formData["bot-field"]} onChange={handleChange} />
                      </label>
                    </p>
                    */}

                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        id="name"
                        placeholder="Your full name"
                        onChange={handleChange}
                        required
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Email address</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        id="email"
                        placeholder="name@example.com"
                        onChange={handleChange}
                        required
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="message" className="form-label">Message</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                        id="message"
                        rows="4"
                        placeholder="Write your message here"
                        onChange={handleChange}
                        required
                      />
                      {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                    </div>

                    {submitError && (
                      <div className="alert alert-danger" role="alert">
                        {submitError}
                      </div>
                    )}

                    <button type="submit" className="btn btn-light" disabled={submitting}>
                      {submitting ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;